import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const LABELS = {
  company_name: "Company", email: "Email", phone: "Phone", service: "Service", headcount: "Headcount / volume",
  location: "Location", message: "Message", role: "Role", experience_years: "Experience (years)", skills: "Skills & past work",
};

export const DetailDialog = ({ item, onClose, onDelete }) => (
  <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-lenis-prevent className="max-h-[85vh] overflow-y-auto border-white/15 bg-[var(--ink-2)] text-[var(--bone)]" data-testid="detail-dialog">
      {item && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display text-4xl font-black uppercase">{item.full_name}</DialogTitle>
            <DialogDescription className="font-mono text-xs text-[var(--bone-2)]">{new Date(item.created_at).toLocaleString("en-IN")}</DialogDescription>
          </DialogHeader>
          <dl className="space-y-4">
            {Object.entries(LABELS).filter(([k]) => item[k]).map(([k, l]) => (
              <div key={k}>
                <dt className="overline text-[var(--signal)]">{l}</dt>
                <dd className="mt-1 whitespace-pre-wrap break-words">{item[k]}</dd>
              </div>
            ))}
          </dl>
          <button onClick={() => onDelete(item)} data-testid="detail-delete-button"
            className="mt-4 self-start rounded-full border border-red-400/60 px-4 py-2 text-sm text-red-300 transition-colors hover:bg-red-500/10">
            Delete record
          </button>
        </>
      )}
    </DialogContent>
  </Dialog>
);
